<script>
  // The three Disclosure steps, plus where the analyst's work currently lives.
  // Assessing and labelling are one step: they concern the same columns, and the
  // recurring task — checking an updated export against the mapping you already
  // wrote — needs the profile and the transformed result side by side.
  //
  // Editing is live against one in-browser draft and nothing reaches the Pod until
  // Confirm, so every step says so rather than leaving the analyst to wonder
  // whether closing an editor kept anything.
  //
  // The steps are navigable, since they sit at the top of every screen and the
  // Back/Next buttons sit at the bottom of a long one. Forward moves obey the
  // same gates the Next buttons do — `labelGate` and `aggregatesGate` — so the
  // stepper can never offer a move the step itself would refuse.
  import Stepper from './Stepper.svelte';
  import Button from './Button.svelte';
  import { disclosureDraft } from '../lib/disclosureDraft.svelte.js';
  import { withSource } from '../lib/nav.svelte.js';
  import { labelGate, aggregatesGate } from '../../../lib/disclosure_core.js';

  let { active = 0 } = $props();

  const ROUTES = $derived(['disclosure/label', 'disclosure/aggregates', 'disclosure/confirm']
    .map((route) => withSource(route, disclosureDraft.sourceId)));
  const label = $derived(labelGate(disclosureDraft));
  const aggregates = $derived(aggregatesGate(disclosureDraft));
  // Only forward moves are gated: going back to fix what a gate complains about
  // is exactly what it is asking for. Each step carries every gate before it.
  const blocks = (i) => {
    if (i <= active) return null;
    if (i > 0 && label.blocked) return label.reason;
    if (i > 1 && aggregates.blocked) return aggregates.reason;
    return null;
  };
</script>

<Stepper steps={['Assess and label', 'Build cubes', 'Confirm']} {active} routes={ROUTES} {blocks} />

{#if disclosureDraft.dirty}
  <div class="draft-status">
    <span class="tag">Not saved yet</span>
    <span>
      Your changes follow you around the app, but they live in this browser tab —
      closing or reloading it discards them. They reach your Pod when you confirm.
    </span>
    {#if active !== 2}
      <Button variant="ghost" to="disclosure/confirm">Review and save</Button>
    {/if}
  </div>
{/if}
